<div class="wrap uk-margin-top">

    <div *ngIf="loading === true" class="uk-position-center">
        <div uk-spinner></div>
    </div>

    <div *ngIf="loading === false">
        <div class="uk-form-stacked uk-margin-large uk-grid-medium" uk-grid>
            <div class="uk-width-12-12 uk-margin-small-top" style="padding-left: 20px;">
                <div class="back-button" [routerLink]="[routerURL]">
                    <img src="../../../assets/icons/Back.svg" width="32px" height="32px" alt="back">
                    <span>{{previousUrlName}}</span>
                </div>
            </div>
            <div class="uk-width-12-12 uk-position-relative uk-margin-top">
                <div class="main-title bold">{{ vehicle.name }} <span class="regular uk-margin-small-left">{{
                        vehicle.brand }} {{ vehicle.model }}</span> </div>
                <!-- <div class="uk-float-right">
                    <button class="back-button button-main-title regular buttonMobile" type="submit"
                        (click)="updateVehicle()" style="padding-right: 20px;">
                        <span class="uk-visible@s uk-text-uppercase">Valider les changements</span>
                        <img src="../../../assets/icons/Edit.svg" width="32px" height="32px" alt="back">
                    </button>
                </div> -->
            </div>
            <div class="uk-width-12-12 uk-margin-top uk-position-relative pointer" style="padding: 10px 20px;"
                *ngIf="nextReservation.state !== 'no-reservation'" (click)="redirectToReservationList()" [ngClass]="{
                'background-cold-grey' : nextReservation.state === 'come-up',
                'background-orange' : nextReservation.state === 'in-progress'
            }">
                <div *ngIf="nextReservation.state === 'come-up'" class="title bold color-white"
                    style="font-size: 15px;">
                    Véhicule réservé
                    <span class="uk-text-small margin-minimal-left regular"
                        humanDateFormat="{{ nextReservation.reservation.ISODateStart }}" noDay="true"
                        shortened="true"></span>
                    <span class="uk-text-small margin-minimal-left regular"
                        hours="{{ nextReservation.reservation.ISODateStart }}"></span>
                    <span class="uk-text-small margin-minimal-left regular"> > </span>
                    <span class="uk-text-small margin-minimal-left regular"
                        humanDateFormat="{{ nextReservation.reservation.ISODateEnd }}" noDay="true"
                        shortened="true"></span>
                    <span class="uk-text-small margin-minimal-left regular"
                        hours="{{ nextReservation.reservation.ISODateEnd }}"></span>
                </div>
                <div *ngIf="nextReservation.state === 'in-progress'" class="title bold color-white"
                    style="font-size: 15px;">
                    En cours d'utilisation
                    <span class="uk-text-small margin-minimal-left regular"
                        humanDateFormat="{{ nextReservation.reservation.ISODateStart }}" noDay="true"
                        shortened="true"></span>
                    <span class="uk-text-small margin-minimal-left regular"
                        hours="{{ nextReservation.reservation.ISODateStart }}"></span>
                    <span class="uk-text-small margin-minimal-left regular"> > </span>
                    <span class="uk-text-small margin-minimal-left regular"
                        humanDateFormat="{{ nextReservation.reservation.ISODateEnd }}" noDay="true"
                        shortened="true"></span>
                    <span class="uk-text-small margin-minimal-left regular"
                        hours="{{ nextReservation.reservation.ISODateEnd }}"></span>
                </div>
                <div class="uk-visible@s uk-position-absolute title bold color-white pointer"
                    style="font-size: 13px; right: 20px; top: 5px;">
                    <span class="vertical-align-middle">Voir toutes les réservations</span>
                    <img class="vertical-align-middle" src="../../../assets/icons/ArrowRightWhite.svg" width="32px"
                        height="32px" alt="back">
                </div>
            </div>
            <div uk-grid class="uk-width-12-12 padding-20 vop-background-white remove-grid-ml-pl"
                [ngClass]="{ 'uk-margin-top': nextReservation.state === 'no-reservation' }"
                style="padding-bottom: inherit; margin-top: inherit;">
                <div class="uk-width-4-12@s" style="min-height: 316.66px;">
                    <div class="img-wrap">
                        <div *ngIf="loadingPhoto === true" class="uk-position-center" uk-spinner></div>
                        <div *ngIf="loadingPhoto === false" uk-lightbox>
                            <a class="uk-button uk-button-default" [href]="vehicle.vehiclePicture">
                                <img [src]="vehicle.vehiclePicture"
                                    onerror="this.src='../../../../assets/icons/Vehicle.svg';this.className='img-error';">
                            </a>
                        </div>
                        <button class="uk-position-absolute button large edit-button" (click)="modifyPhoto()">
                            <img src="../../../assets/icons/Edit.svg" width="32px" height="32px" alt="back">
                        </button>
                    </div>
                </div>
                <div class="uk-width-8-12@s uk-grid-small@s" uk-grid>
                    <div class="uk-width-1-2@s">
                        <div class="uk-margin-left uk-margin-bottom">
                            <label class="label">Immatriculation</label>
                            <div class="uk-form-controls">
                                <span *ngIf="session.role.ability !== 'super-admin'"
                                    class="color-cold-grey bold uk-width-1-1">{{ vehicle.name }}</span>
                                <input *ngIf="session.role.ability === 'super-admin'"
                                    class="input alt color-cold-grey bold uk-width-1-1" type="text"
                                    [(ngModel)]="vehicle.name">
                            </div>
                        </div>
                        <div class="uk-margin-left uk-margin-bottom">
                            <label class="label">Marque</label>
                            <div class="uk-form-controls">
                                <input class="input alt color-cold-grey bold uk-width-1-1" type="text"
                                    [(ngModel)]="vehicle.brand">
                            </div>
                        </div>
                        <div class="uk-margin-left">
                            <label class="label">Modèle</label>
                            <div class="uk-form-controls">
                                <input class="input alt color-cold-grey bold uk-width-1-1" type="text"
                                    [(ngModel)]="vehicle.model">
                            </div>
                        </div>
                        <div class="uk-width-7-12 uk-margin-left uk-margin-top">
                            <label class="label">Carburant</label>
                            <div class="uk-form-controls gridFuel">
                                <!-- <span *ngIf="vehicle.idDisabledVehicle === 0" class="material-icons color-red vertical-align-middle">local_gas_station</span> -->
                                <span *ngIf="vehicle.vehicleFuel == 0"
                                    class="material-icons color-green vertical-align-middle iconFuel">ev_station</span>
                                <span *ngIf="vehicle.vehicleFuel == 1"
                                    class="material-icons color-orange vertical-align-middle iconFuel">local_gas_station</span>
                                <span *ngIf="vehicle.vehicleFuel == 2"
                                    class="material-icons color-red vertical-align-middle iconFuel">local_gas_station</span>
                                <span *ngIf="vehicle.vehicleFuel == 3"
                                    class="material-icons color-red vertical-align-middle iconFuel">local_gas_station</span>
                                <span *ngIf="vehicle.vehicleFuel > 3"
                                    class="material-icons color-black vertical-align-middle iconFuel">local_gas_station</span>
                                <select class="combo-list alt color-cold-grey bold uk-width-1-1 uk-align-left labelFuel"
                                    [(ngModel)]="vehicle.vehicleFuel">
                                    <option value=0>Electrique</option>
                                    <option value=1>Gazole</option>
                                    <option value=2>SP-95</option>
                                    <option value=3>SP-98</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="uk-width-1-2@s">
                        <div class="uk-margin-left uk-margin-bottom">
                            <label class="label">Numéro de boîtier</label>
                            <div class="uk-form-controls">
                                <span class="color-cold-grey bold uk-width-1-1">{{ vehicle.idEquipment }}</span>
                            </div>
                        </div>
                        <div class="uk-margin-left uk-margin-bottom" style="height: 55px;">
                            <label class="label">État du véhicule</label>
                            <div class="uk-form-controls">
                                <span class="color-cold-grey bold uk-width-1-1 uk-text-uppercase"
                                    *ngIf="vehicle.idDisabledVehicle > 0">
                                    <span
                                        class="material-icons color-red vertical-align-middle">fiber_manual_record</span>
                                    <span class="vertical-align-middle" style="margin-left: 5px;">Désactivé</span>
                                </span>
                                <span class="color-cold-grey bold uk-width-1-1 uk-text-uppercase"
                                    *ngIf="vehicle.idDisabledVehicle === 0">
                                    <span
                                        class="material-icons color-green vertical-align-middle">fiber_manual_record</span>
                                    <span class="vertical-align-middle" style="margin-left: 5px;">Activé</span>
                                </span>
                            </div>
                        </div>
                        <div class="uk-margin-left uk-margin-bottom">
                            <label class="label">Catégorie</label>
                            <div class="uk-form-controls gridFuel">
                                <!-- <input class="input alt color-cold-grey bold uk-width-1-1" type="text"
                                    [(ngModel)]="vehicle.vehicleCategeory"> -->
                                <span *ngIf="vehicle.vehicleCategeory == 'A'"
                                    class="material-icons color-black vertical-align-middle iconFuel">directions_car</span>
                                <span *ngIf="vehicle.vehicleCategeory == 'B'"
                                    class="material-icons color-black vertical-align-middle iconFuel">local_taxi</span>
                                <span *ngIf="vehicle.vehicleCategeory == 'C'"
                                    class="material-icons color-black vertical-align-middle iconFuel">airport_shuttle</span>
                                <span *ngIf="vehicle.vehicleCategeory == 'D'"
                                    class="material-icons color-black vertical-align-middle iconFuel">local_shipping</span>
                                <span *ngIf="vehicle.vehicleCategeory == 'E'"
                                    class="material-icons color-black vertical-align-middle iconFuel">directions_bus</span>
                                <select class="combo-list alt color-cold-grey bold uk-width-1-1 uk-align-left labelFuel"
                                    [(ngModel)]="vehicle.vehicleCategeory">
                                    <option value="A">Citadine (A)</option>
                                    <option value="B">Routiere (B)</option>
                                    <option value="C">Familiale (C)</option>
                                    <option value="D">Utilitaire (D)</option>
                                    <option value="E">Autre (E)</option>
                                </select>
                            </div>
                        </div>

                        <div class="uk-margin-left uk-margin-bottom">
                            <!-- <button class="back-button button-main-title regular buttonMobile" type="submit"
                                (click)="updateVehicle()" style="padding-right: 20px;">
                                <span class="uk-visible@s uk-text-uppercase">Valider les changements</span>
                                <img src="../../../assets/icons/Edit.svg" width="32px" height="32px" alt="back">
                            </button> -->

                            <button class="button bold uk-display-inline-block uk-margin-small-left"
                                *ngIf="vehicle.idDisabledVehicle === 0 || session.role.ability === 'super-admin'"
                                (click)="updateVehicle()">
                                <span>Valider les changements</span>
                                <img src="../../../assets/icons/Edit.svg" width="32px" height="32px" alt="back">
                            </button>
                        </div>

                        <!-- Parti commentaire pas encore integré -->

                        <!-- <div class="uk-margin-left">
                            <label class="label">Commentaire</label>
                            <div class="uk-form-controls">
                                <input class="input alt color-cold-grey bold uk-width-1-1" type="text"
                                    [(ngModel)]="vehicle.commentaire">
                            </div>
                        </div> -->

                        <!-- Parti commentaire pas encore integré -->
                    </div>
                </div>
            </div>
            <div class="uk-width-12-12 padding-20 vop-background-white" style="margin-top: 0px;">
                <div class="title bold uk-margin-small-bottom">
                    Actions
                </div>
                <div uk-grid class="remove-grid-ml-pl uk-form-stacked">
                    <div class="uk-width-1-1">
                        <div class="uk-margin">
                            <div class="uk-form-controls uk-margin-small-top">
                                <a
                                    class="button bold uk-display-inline-block uk-margin-small-left uk-margin-bottom"
                                    href="#position-vehicle"
                                    uk-toggle
                                    (click)="appPositionVehicle.fixCenter()">
                                    <span>Localiser ce véhicule</span>
                                    <img class="uk-margin-left" src="../../../assets/icons/Map-new.svg" width="32px"
                                        height="32px" alt="Localiser">
                                </a>
                                <button class="button bold uk-display-inline-block uk-margin-small-left"
                                    *ngIf="vehicle.idDisabledVehicle === 0" (click)="activateVehicle(false)">
                                    <span>Désactiver le véhicule</span>
                                    <img src="../../../assets/icons/Close.svg" class="uk-margin-left" width="32px"
                                        height="32px" alt="back">
                                </button>
                                <button class="button bold uk-display-inline-block uk-margin-small-left"
                                    *ngIf="vehicle.idDisabledVehicle > 0" (click)="activateVehicle(true)">
                                    <span>Activer le véhicule</span>
                                    <img src="../../../assets/icons/OK.svg" class="uk-margin-left" width="32px"
                                        height="32px" alt="back">
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="uk-width-12-12 padding-20 vop-background-white" style="margin-top: 0px;">
                <div class="uk-width-12-12 separator-horizontal uk-margin-bottom"></div>
                <div class="title bold uk-margin-small-bottom">
                    Commandes
                </div>
                <div uk-grid class="remove-grid-ml-pl uk-form-stacked">
                    <div class="uk-width-1-1">
                        <div class="uk-margin">
                            <div class="uk-form-controls uk-margin-small-top">
                                <button
                                    class="button bold uk-display-inline-block uk-margin-small-left uk-margin-bottom"
                                    (click)="openVehicle()">
                                    <span>Ouvrir le véhicule</span>
                                    <img class="uk-margin-left" src="../../../assets/icons/Keys.svg" width="32px"
                                        height="32px" alt="back">
                                </button>
                                <button
                                    class="button bold uk-display-inline-block uk-margin-small-left uk-margin-bottom"
                                    (click)="closeVehicle()">
                                    <span>Fermer le véhicule</span>
                                    <img class="uk-margin-left" src="../../../assets/icons/Keys.svg" width="32px"
                                        height="32px" alt="back">
                                </button>
                                <button class="button bold uk-display-inline-block uk-margin-small-left"
                                    (click)="stopEngine()">
                                    <span>Couper le moteur</span>
                                    <img class="uk-margin-left" src="../../../assets/icons/Close.svg" width="32px"
                                        height="32px" alt="back">
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="session.role.ability === 'super-admin'"
                class="uk-width-12-12 padding-20 vop-background-white uk-text-right" style="margin-top: 0px;">
                <button [routerLink]="['/ressource/vehicle/logs', id]"
                    class="back-button bold uk-display-inline-block uk-margin-right">
                    <img class="uk-margin-small-right" src="../../../assets/icons/Infos.svg" width="32px" height="32px"
                        alt="back">
                    <span class="color-dark-gray">Voir les logs techniques</span>
                </button>
            </div>
            <div class="uk-width-12-12 padding-20 vop-background-white" style="margin-top: 0px; padding-bottom: 0px;">
            </div>

            <app-rate-management-vehicle class="simulateur" *ngIf="session.role.ability === 'super-admin'">
            </app-rate-management-vehicle>

            <div class="uk-width-12-12 padding-20" *ngIf="session.role.ability === 'super-admin'">

                <div *ngIf="reservationsVenir.length > 0" class="title bold uk-margin-small-bottom">
                    <span>Réservation à venir</span>
                </div>
                <div *ngIf="reservationsVenir.length > 0" uk-grid
                    class="remove-grid-ml-pl uk-margin-remove-top uk-margin-medium-bottom">
                    <div uk-grid *ngFor="let reservation of reservationsVenir; let i = index"
                        class="uk-width-1-1 reservation-list remove-grid-ml-pl pointer"
                        [routerLink]="['/reservation/informations', reservation.Id]"
                        [queryParams]="{from: '/ressource/vehicle/informations/'+id, name: 'Véhicule ' + vehicle.name}">
                        <div class="uk-width-1-7@s uk-width-1-3 item-column bold" style="font-size: 17px;">
                            <div class="uk-display-block">
                                <span class="uk-text-small" humanDateFormat="{{ reservation.ISODateStart }}"
                                    noDay="true" shortened="true"></span>
                                <span class="uk-text-small uk-margin-small-left regular"
                                    hours="{{ reservation.ISODateStart }}"></span>
                            </div>
                            <div class="uk-display-block">
                                <span class="uk-text-small" humanDateFormat="{{ reservation.ISODateEnd }}" noDay="true"
                                    shortened="true"></span>
                                <span class="uk-text-small uk-margin-small-left regular"
                                    hours="{{ reservation.ISODateEnd }}"></span>
                            </div>
                            <div class="separator"></div>
                        </div>
                        <div class="uk-width-1-7@s uk-width-1-3 item-column light uk-text-uppercase uk-text-center"
                            style="font-size: 17px;">
                            {{ reservation.Vehicle }}
                        </div>
                        <div class="uk-width-1-5@s uk-width-1-3 item-column bold uk-text-uppercase"
                            style="font-size: 13px;">
                            {{ reservation.User }}
                        </div>
                        <div *ngIf="session.role.ability === 'super-admin'"
                            class="uk-visible@s uk-width-1-6 item-column light uk-text-uppercase"
                            style="font-size: 13px;">
                            {{ reservation.CodeSociety }}
                        </div>
                        <div class="uk-width-expand item-column"></div>
                        <div class="uk-visible@s uk-width-1-12 item-column" *ngIf="reservation.demo === true"
                            style="font-size: 13px;">
                            <span class="uk-badge" *ngIf="reservation.demo === true">Staff</span>
                            <!-- uk-display-inline-block -->
                        </div>
                        <div class="uk-visible@s  uk-width-1-12 item-column" style="font-size: 15px;">
                            #{{ reservation.Code }}
                        </div>
                    </div>
                </div>

                <div *ngIf="reservationsDemarrer.length > 0" class="title bold uk-margin-small-bottom">
                    <span>RÉSERVATIONS DÉMARRÉES</span>
                </div>
                <div *ngIf="reservationsDemarrer.length > 0" uk-grid
                    class="remove-grid-ml-pl uk-margin-remove-top uk-margin-small-bottom">
                    <div uk-grid *ngFor="let reservation of reservationsDemarrer; let i = index"
                        class="uk-width-1-1 reservation-list remove-grid-ml-pl pointer"
                        [routerLink]="['/reservation/informations', reservation.Id]"
                        [queryParams]="{from: '/ressource/vehicle/informations/'+id, name: 'Véhicule ' + vehicle.name}">
                        <div class="uk-width-1-7@s uk-width-1-3 item-column bold" style="font-size: 17px;">
                            <div class="uk-display-block">
                                <span class="uk-text-small" humanDateFormat="{{ reservation.ISODateStart }}"
                                    noDay="true" shortened="true"></span>
                                <span class="uk-text-small uk-margin-small-left regular"
                                    hours="{{ reservation.ISODateStart }}"></span>
                            </div>
                            <div class="uk-display-block">
                                <span class="uk-text-small" humanDateFormat="{{ reservation.ISODateEnd }}" noDay="true"
                                    shortened="true"></span>
                                <span class="uk-text-small uk-margin-small-left regular"
                                    hours="{{ reservation.ISODateEnd }}"></span>
                            </div>
                            <div class="separator"></div>
                        </div>
                        <div class="uk-width-1-7@s uk-width-1-3 item-column light uk-text-uppercase uk-text-center"
                            style="font-size: 17px;">
                            {{ reservation.Vehicle }}
                        </div>
                        <div class="uk-width-1-5@s uk-width-1-3 item-column bold uk-text-uppercase"
                            style="font-size: 13px;">
                            {{ reservation.User }}
                        </div>
                        <div *ngIf="session.role.ability === 'super-admin'"
                            class="uk-visible@s uk-width-1-6 item-column light uk-text-uppercase"
                            style="font-size: 13px;">
                            {{ reservation.CodeSociety }}
                        </div>
                        <div class="uk-width-expand item-column"></div>
                        <div class="uk-visible@s uk-width-1-12 item-column" *ngIf="reservation.demo === true"
                            style="font-size: 13px;">
                            <span class="uk-badge" *ngIf="reservation.demo === true">Staff</span>
                            <!-- uk-display-inline-block -->
                        </div>
                        <div class="uk-visible@s  uk-width-1-12 item-column" style="font-size: 15px;">
                            #{{ reservation.Code }}
                        </div>
                    </div>
                </div>

                <button *ngIf="reservationsDemarrer.length > 0 || reservationsVenir.length > 0"
                    class="button bold button-align uk-display-inline-block" [routerLink]="['/reservation/list']"
                    [queryParams]="{vehicule: vehicle.name}" type="button" uk-toggle style="border-radius: 40px;">
                    <span>Voir les Reservation de {{ vehicle.name }}</span>
                </button>



                <div class="uk-margin-large-bottom">
                </div>

                <div class="title bold uk-margin-medium-bottom">
                    <span>États des lieux, états gestionnaires et sinistres</span>
                </div>
                <button class="button bold button-align uk-display-inline-block uk-float-right" type="button"
                    href="#add-manager-state-of-car" uk-toggle style="border-radius: 40px;">
                    <span>Ajouter un état gestionnaire</span>
                    <img src="../../../assets/icons/Add.svg" width="32px" height="32px" alt="back"
                        class="uk-margin-left">
                </button>

                <!-- <div *ngIf="loadingState === true" class="uk-width-1-1 uk-position-relative uk-text-center">
                    <div uk-spinner></div>
                </div> -->
                <div *ngIf="stateNoResult === true || (loadingState === false && getEtatgestionnaire(states).length === 0)"
                    class="bold uk-width-1-1">
                    <div>Aucun état enregistré pour ce véhicule.</div>
                </div>
                <div *ngIf="loadingState === false" class="uk-width-1-1"
                    style="width: calc(100% + 20px); max-width: calc(100% + 20px);">
                    <div uk-grid *ngFor="let state of getEtatgestionnaire(states); let i = index"
                        class="uk-width-1-1 item-list light color-grey remove-grid-ml-pl" style="height: 124px;">
                        <div class="uk-width-2-12 item-column img-wrap" style="background: #eaeaea;">
                            <div uk-lightbox>
                                <a class="uk-button uk-button-default" [href]="state.imgs[0]">
                                    <img class="uk-position-absolute" [src]="state.imgs[0]" alt="adherent"
                                        onerror="this.src='../../../../assets/img/no-photo.png';this.className='img-error';" />
                                </a>
                            </div>
                        </div>
                        <div class="uk-width-10-12 item-column remove-grid-ml-pl" uk-grid
                            style="padding-left: 20px !important; padding-right: 20px !important;">
                            <div class="uk-width-4-12 item-column bold border" style="font-size: 15px;">
                                <span *ngIf="state.stateType === 'manager'" class="title">État gestionnaire</span>
                            </div>
                            <div class="uk-visible@s uk-width-2-12 item-column regular border" style="font-size: 15px;">
                                <span humanDateFormat="{{ state.ISOCreated }}" noDay="true" shortened="true"></span>
                            </div>
                            <div class="uk-visible@s uk-width-2-12 item-column regular border" style="font-size: 15px;">
                                <span hours="{{ state.ISOCreated }}"></span>
                            </div>
                            <div class="uk-width-2-12 item-column regular border" style="font-size: 15px;">
                                <div *ngIf="state.stateType === 'manager'">
                                    <span class="material-icons vertical-align-middle"
                                        [class.color-green]="state.state === 0">fiber_manual_record</span>
                                    <span *ngIf="state.state === 0"
                                        class="title bold vertical-align-middle uk-margin-small-left">Publié</span>
                                    <span *ngIf="state.state === 1"
                                        class="title bold vertical-align-middle uk-margin-small-left">Archivé</span>
                                </div>
                            </div>
                            <div class="uk-width-2-12 item-column border">
                                <button *ngIf="state.stateType === 'state'" class="back-button uk-text-right"
                                    href="#state-of-car-management" uk-toggle (click)="bindSinister(state)">
                                    <img src="../../../assets/icons/Edit.svg" width="32px" height="32px" alt="edit" />
                                </button>
                                <button *ngIf="state.stateType === 'manager'" class="back-button uk-text-right"
                                    href="#manager-state-of-car-informations" uk-toggle
                                    (click)="bindManagerState(state)">
                                    <img src="../../../assets/icons/Edit.svg" width="32px" height="32px" alt="edit" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="uk-align-center">
                    <div class="uk-display-inline-block research-form-controls">
                        <div class="uk-form-controls uk-display-inline-block uk-margin-small-left">
                            <button class="uk-button round-button uk-display-inline-block@m"
                                [class.round-button-toggle]="choix === 0" (click)="changeStatus(0)">
                                sinistres
                            </button>
                        </div>
                        <div
                            class="uk-form-controls uk-display-inline-block uk-margin-small-left@s uk-margin-small-left">
                            <button class="uk-button round-button uk-display-inline-block@m"
                                [class.round-button-toggle]="choix === 1" (click)="changeStatus(1)">
                                État de sortie
                            </button>
                        </div>
                        <!-- <div class="uk-form-controls uk-display-inline-block uk-margin-small-left@s uk-margin-small-left">
                                            <button class="uk-button round-button uk-display-inline-block@m" [class.round-button-toggle]="choix === 3" (click)="changeStatus(3)">
                                                sinistres
                                            </button>
                                        </div> -->
                        <div
                            class="uk-form-controls uk-display-inline-block uk-margin-small-left@s uk-margin-small-left">
                            <button class="uk-button round-button uk-display-inline-block@m"
                                [class.round-button-toggle]="choix === 2" (click)="changeStatus(2)">
                                Archives
                            </button>
                        </div>
                    </div>
                </div>
                <div class="uk-form-stacked uk-margin-medium-bottom">
                    <!-- <div class="uk-margin uk-display-inline-block uk-form-controls uk-display-inline-block"
                                        style="margin-left: inherit;">
                                        <button class="uk-button round-button uk-display-inline-block"
                                            [class.round-button-toggle]="archivedOnly === true"
                                            (click)="changeArchivedOnlyFilter(!archivedOnly)">
                                            <span *ngIf="archivedOnly === false">Voir les archives</span>
                                            <span *ngIf="archivedOnly === true">Archives visibles</span>
                                        </button>
                                    </div> -->

                    <!-- <div class="uk-width-1-2@s uk-display-inline-block research-form-controls">
                                        <div class="uk-form-controls uk-display-inline-block">
                                            <button class="uk-button round-button uk-display-inline-block@m" [class.round-button-toggle]="choix === 0" (click)="changeStatus(0)">
                                                Tout
                                            </button>
                                        </div>
                                        <div class="uk-form-controls uk-display-inline-block uk-margin-small-left@s">
                                            <button class="uk-button round-button uk-display-inline-block@m" [class.round-button-toggle]="choix === 1" (click)="changeStatus(1)">
                                                Gestionnaire
                                            </button>
                                        </div>
                                        <div class="uk-form-controls uk-display-inline-block uk-margin-small-left@s">
                                            <button class="uk-button round-button uk-display-inline-block@m" [class.round-button-toggle]="choix === 2" (click)="changeStatus(2)">
                                                États des lieux 
                                            </button>
                                        </div>
                                        <div class="uk-form-controls uk-display-inline-block uk-margin-small-left@s">
                                            <button class="uk-button round-button uk-display-inline-block@m" [class.round-button-toggle]="choix === 3" (click)="changeStatus(3)">
                                                Sinistres
                                            </button>
                                        </div>
                                        <div class="uk-form-controls uk-display-inline-block uk-margin-small-left@s">
                                            <button class="uk-button round-button uk-display-inline-block@m" [class.round-button-toggle]="choix === 4" (click)="changeStatus(4)">
                                                Archives
                                            </button>
                                        </div>
                                    </div> -->


                    <!-- <div class="uk-margin uk-display-inline-block research-form-controls uk-margin-left"
                                        >
                                        <div class="uk-form-controls uk-display-inline-block uk-position-relative uk-width-1-1 search">
                                            <button class="uk-form-icon uk-form-icon-flip pointer" type="submit"
                                                style="border: none; background: inherit;">
                                                <img src="../../../../assets/icons/Search.svg" width="24px" height="24px" alt="user" />
                                            </button>
                                            <input class="search-bar" type="text" disabled placeholder="Rechercher">
                                        </div>
                                    </div> -->
                    <!-- <button class="button bold button-align uk-display-inline-block uk-float-right" type="button"
                                        href="#add-manager-state-of-car" uk-toggle style="border-radius: 40px;">
                                        <span>Ajouter un état gestionnaire</span>
                                        <img src="../../../assets/icons/Add.svg" width="32px" height="32px" alt="back"
                                            class="uk-margin-left">
                                    </button> -->
                </div>
                <div *ngIf="loadingState === true" class="uk-width-1-1 uk-position-relative uk-text-center">
                    <div uk-spinner></div>
                </div>
                <div *ngIf="stateNoResult === true || (loadingState === false && filterStates(states).length === 0)"
                    class="bold uk-width-1-1">
                    <!-- <div *ngIf="choix === 0">Aucun état enregistré pour ce véhicule.</div>
                                    <div *ngIf="choix === 1">Aucun état de sortie pour ce véhicule.</div>
                                    <div *ngIf="choix === 2">Aucun sinistre pour ce véhicule.</div>
                                    <div *ngIf="choix === 3">Aucune archive pour ce véhicule.</div> -->
                    <div *ngIf="choix === 0">Aucun sinistre pour ce véhicule.</div>
                    <div *ngIf="choix === 1">Aucun état de sortie pour ce véhicule.</div>
                    <div *ngIf="choix === 2">Aucune archive pour ce véhicule.</div>
                </div>
                <div *ngIf="loadingState === false" class="uk-width-1-1"
                    style="width: calc(100% + 20px); max-width: calc(100% + 20px);">
                    <div uk-grid *ngFor="let state of filterStates(states); let i = index"
                        class="uk-width-1-1 item-list light color-grey remove-grid-ml-pl" style="height: 124px;">
                        <div class="uk-width-2-12 item-column img-wrap" style="background: #eaeaea;">
                            <div uk-lightbox>
                                <a class="uk-button uk-button-default" [href]="state.imgs[0]">
                                    <img class="uk-position-absolute" [src]="state.imgs[0]" alt="adherent"
                                        onerror="this.src='../../../../assets/img/no-photo.png';this.className='img-error';" />
                                </a>
                            </div>
                        </div>
                        <div class="uk-width-10-12 item-column remove-grid-ml-pl" uk-grid
                            style="padding-left: 20px !important; padding-right: 20px !important;">
                            <div class="uk-width-4-12 item-column bold border" style="font-size: 15px;">
                                <!-- <span *ngIf="state.stateType === 'manager'" class="title">État gestionnaire</span>
                                <span *ngIf="state.stateType === 'state' && state.type === 0" class="title">État des lieux d'entrée</span>
                                <span *ngIf="state.stateType === 'state' && state.type === 1" class="title">Sinistres & États des lieux</span>
                                <span *ngIf="state.stateType === 'state' && state.type === 2" class="title">État des lieux de sortie</span> -->
                                <!-- changement etat -->
                                <span *ngIf="state.stateType === 'manager'" class="title">État gestionnaire</span>
                                <span *ngIf="state.stateType === 'state' && state.type === 0" class="title">État des
                                    lieux de sortie</span>
                                <span *ngIf="state.stateType === 'state' && state.type === 1" class="title">Sinistres &
                                    États des lieux</span>
                                <span *ngIf="state.stateType === 'state' && state.type === 2" class="title">État des
                                    lieux d'entrée</span>
                            </div>
                            <div class="uk-visible@s  uk-width-2-12 item-column regular border"
                                style="font-size: 15px;">
                                <span humanDateFormat="{{ state.ISOCreated }}" noDay="true" shortened="true"></span>
                            </div>
                            <div class="uk-visible@s uk-width-2-12 item-column regular border" style="font-size: 15px;">
                                <span hours="{{ state.ISOCreated }}"></span>
                            </div>
                            <div class="uk-width-2-12 item-column regular border" style="font-size: 15px;">
                                <div *ngIf="state.stateType === 'state'">
                                    <span class="material-icons vertical-align-middle"
                                        [class.color-green]="state.state === 0"
                                        [class.color-orange]="state.state === 1">fiber_manual_record</span>
                                    <span *ngIf="state.state === 0"
                                        class="title bold vertical-align-middle uk-margin-small-left">Nouveau</span>
                                    <span *ngIf="state.state === 1"
                                        class="title bold vertical-align-middle uk-margin-small-left">À traîter</span>
                                    <span *ngIf="state.state === 2"
                                        class="title bold vertical-align-middle uk-margin-small-left">Archivé</span>
                                </div>
                                <div *ngIf="state.stateType === 'manager'">
                                    <span class="material-icons vertical-align-middle"
                                        [class.color-green]="state.state === 0">fiber_manual_record</span>
                                    <span *ngIf="state.state === 0"
                                        class="title bold vertical-align-middle uk-margin-small-left">Publié</span>
                                    <span *ngIf="state.state === 1"
                                        class="title bold vertical-align-middle uk-margin-small-left">Archivé</span>
                                </div>
                            </div>
                            <div class="uk-width-2-12 item-column border">
                                <button *ngIf="state.stateType === 'state'" class="back-button uk-text-right"
                                    href="#state-of-car-management" uk-toggle (click)="bindSinister(state)">
                                    <img src="../../../assets/icons/Edit.svg" width="32px" height="32px" alt="edit" />
                                </button>
                                <button *ngIf="state.stateType === 'manager'" class="back-button uk-text-right"
                                    href="#manager-state-of-car-informations" uk-toggle
                                    (click)="bindManagerState(state)">
                                    <img src="../../../assets/icons/Edit.svg" width="32px" height="32px" alt="edit" />
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- a check pas encore fini -->
                    <!-- <div *ngIf="choix === 0" uk-grid class="remove-grid-ml-pl uk-margin-remove-top uk-width-1-1">
                            <div class="title bold uk-margin-small-bottom uk-margin-medium-top">
                                <span>Historique des statuts</span>
                            </div>
                            <div class="uk-width-12-12 item-column bold uk-margin-small-left" style="font-size: 15px;">
                                <span>EN COURS (ÉTAT DES LIEUX D'ENTRÉE SANS PRISE DE PHOTO)</span>
                            </div>
                        </div> -->
                    <!-- a check pas encore fini -->
                </div>
            </div>
        </div>
    </div>
</div>

<app-position-vehicle [latitude]="vehicle.latitude" [longitude]="vehicle.longitude" #appPositionVehicle>
</app-position-vehicle>

<app-manager-state-of-car-informations [id]="boundManagerState.id" [relatedStates]="boundManagerState.relatedStates"
    (changed)="refreshStatesOfCar()"></app-manager-state-of-car-informations>

<app-add-manager-state-of-car [id]="id" (changed)="refreshStatesOfCar()"></app-add-manager-state-of-car>

<app-states-of-car-management [statesOfCar]="boundStateOfCar.statesOfCar" (changed)="loadInformations()">
</app-states-of-car-management>